export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.6.4',
};
//# sourceMappingURL=buildEnv.js.map